var React = require('react');

function Lightning (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.18041 22.4863L14.7101 10.5114C14.9033 10.2794 15 10.0475 15 9.79618C15 9.34193 14.6521 9.023 14.1785 9.023H8.53415L11.3563 1.31036C11.7816 0.13124 10.5734 -0.487316 9.81958 0.469516L0.280282 12.454C0.0966482 12.686 0 12.9083 0 13.1596C0 13.6138 0.347937 13.9425 0.821519 13.9425H6.45618L3.63402 21.6454C3.20876 22.8342 4.41688 23.4432 5.18041 22.4863ZM9.23969 12.1448H3.1411L8.29252 5.37931L5.75065 10.811H11.8492L6.70747 17.5764L9.23969 12.1448Z","fill":"#FFD12E"}));
}

Lightning.defaultProps = {"width":"15","height":"23","viewBox":"0 0 15 23","fill":"none"};

module.exports = Lightning;

Lightning.default = Lightning;
